import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosAuthInstance from "../../../utils/axios/axiosAuthInstance";

const View = () => {
  const { id } = useParams()
  const [companyData, setCompanyData] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchCmpanyBrandingData = async () => {
    try {
      const response = await axiosAuthInstance.get(`company-branding/detail/${id}`)
      setCompanyData(response.data.result)
    } catch (error) {
      console.error('Error fetching company data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCmpanyBrandingData()
  }, [id])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!companyData) {
    return <div>No company branding data found.</div>
  }

  return (
    <div className='p-4'>
      <div className='bg-white text-black shadow-md rounded-lg p-6'>
        <h2 className='text-xl font-semibold mb-4'>Company Branding Details</h2>
        <div className='overflow-x-auto'>
          <table className='table-auto w-full border-collapse'>
            <tbody>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Name</td>
                <td className='border-b px-4 py-2'>{companyData.company.name}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Logo</td>
                <td className='border-b px-4 py-2'>
                  {companyData.logo ? (
                    <img
                      src={companyData.logo}
                      alt='Team'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  ) : (
                    <span>No logo available</span>
                  )}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Tagline</td>
                <td className='border-b px-4 py-2'>{companyData.tagline}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>About</td>
                <td className='border-b px-4 py-2'>{companyData.about}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>History</td>
                <td className='border-b px-4 py-2'>{companyData.history}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Vision</td>
                <td className='border-b px-4 py-2'>{companyData.vision}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>
                  Mission
                </td>
                <td className='border-b px-4 py-2'>{companyData.mission}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Contact</td>
                <td className='border-b px-4 py-2'>{companyData.contact}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>
                  Email
                </td>
                <td className='border-b px-4 py-2'>
                  {companyData.email}
                </td>
              </tr>
              {companyData.facebook && <tr>
                <td className='border-b px-4 py-2 font-medium'>Facebook</td>
                <td className='border-b px-4 py-2'>{companyData.facebook}</td>
              </tr>}
              {companyData.twitter && <tr>
                <td className='border-b px-4 py-2 font-medium'>Twitter</td>
                <td className='border-b px-4 py-2'>{companyData.twitter}</td>
              </tr>}
              {companyData.linkedin && <tr>
                <td className='border-b px-4 py-2 font-medium'>Linkedin</td>
                <td className='border-b px-4 py-2'>{companyData.linkedin}</td>
              </tr>}
              {companyData.instagram && <tr>
                <td className='border-b px-4 py-2 font-medium'>Instagram</td>
                <td className='border-b px-4 py-2'>{companyData.instagram}</td>
              </tr>}
              {companyData.website && <tr>
                <td className='border-b px-4 py-2 font-medium'>Website</td>
                <td className='border-b px-4 py-2'>{companyData.website}</td>
              </tr>}
              {companyData?.about_series &&
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>About Series</td>
                  <td className='border-b px-4 py-2'>{companyData.about_series}</td>
                </tr>
              }
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Username</td>
                <td className='border-b px-4 py-2'>{companyData.username}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default View
